import api from "./Api";

class BoletoLicencaRecebivelService {
  GetBoletoLicencaRecebivel(payload) {
    return api.get("/v1/boletolicencarecebivel/" + payload).then((response) => {
      return response.data;
    });
  }

  PostBoletoLicencaRecebivel(payload) {
    return api.post("/v1/boletolicencarecebivel/", payload).then((response) => {
      return response.data;
    });
  }

  PutBoletoLicencaRecebivel(payload) {
    return api.put("/v1/boletolicencarecebivel/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteBoletoLicencaRecebivel(payload) {
    return api
      .delete("/v1/boletolicencarecebivel/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetBoletoLicencaRecebivelOData(payload) {
    return api
      .get("/OData/boletolicencarecebivel" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new BoletoLicencaRecebivelService();
